import React from "react";
import { PricesFromWithChip } from "../PricesFromWithChip/PricesFromWithChip";
import { Price } from "../types/price";
import { SuiteCardBase, SuiteCardBaseProps } from "./SuiteCardBase";

export type SuiteCardProps = SuiteCardBaseProps & {
  pricesDisclaimer?: string;
  prices: Price[];
};

export const SuiteCard: React.FC<React.PropsWithChildren<SuiteCardProps>> = ({
  pricesDisclaimer,
  prices,
  ...props
}) => {
  return (
    <SuiteCardBase {...props}>
      <PricesFromWithChip
        prices={prices}
        pricesDisclaimer={pricesDisclaimer}
        layout="column"
        align="force-right"
      />
    </SuiteCardBase>
  );
};
